import { createSlice } from "@reduxjs/toolkit";
import { getFacultyDashboard, getFacultyDashboardPayment } from "../../builders/faculty/faculty-dashboard.builder";

const initialState = {
    isFacultyDashboardInformationFilled: false,
    isFacultyDashboardInformationNextClicked: true,

    isfacultyDashboardPaymentInformationFilled:false,
    isfacultyDashboardPaymentInformationNextClicked: true,

    loading: false,
    facultyDashboard: [],
    facultyDashboardPayment: [],
    module: [],
    topic: [],
    facultyDashboardData: [],
    facultyDashboardPaymentData: []
}

const facultyDashboardeSlice = createSlice({
    name:'facultyDashboard',
    initialState,
    reducers:{
        facultyDashboardInformationFilled: (state,action) => {
            state.isFacultyDashboardInformationFilled = action.payload
        },
        facultyDashboardInformationNextClicked: (state, action) => {
            state.isFacultyDashboardInformationNextClicked = action.payload
        },

        facultyDashboardPaymentInformationFilled: (state,action) => {
            state.isfacultyDashboardPaymentInformationFilled = action.payload
        },
        facultyDashboardPaymentInformationNextClicked: (state, action) => {
            state.isfacultyDashboardPaymentInformationNextClicked = action.payload
        },
        clearExtraReducers : (state) => {
            state.loading = false,
            state.facultyDashboard = [],
            state.facultyDashboardPayment = [],
            state.module = [],
            state.topic = [],
            state.facultyDashboardData = []
            state.facultyDashboardPaymentData = []
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getFacultyDashboard.pending, (state)=>{
            state.loading = true,
            state.assessment = []
        }),
        builder.addCase(getFacultyDashboard.fulfilled, (state, action)=>{
            state.loading = false
            state.facultyDashboard = action.payload
        }),
        builder.addCase(getFacultyDashboard.rejected, (state)=>{
            state.loading = false
        }),

        builder.addCase(getFacultyDashboardPayment.pending, (state)=>{
            state.loading = true,
            state.assessment = []
        }),
        builder.addCase(getFacultyDashboardPayment.fulfilled, (state, action)=>{
            state.loading = false
            state.facultyDashboardPayment = action.payload
        }),
        builder.addCase(getFacultyDashboardPayment.rejected, (state)=>{
            state.loading = false
        })
    }
})

export const { FacultyDashboardInformationFilled, loading } = facultyDashboardeSlice.actions

export default facultyDashboardeSlice.reducer;